export class ClientFieldParameter {
  // no definition because the field has only an optional selection to help
}
